import { useState } from "react";
import { Heart } from "lucide-react";

const PRESETS = [500, 1000, 2500];
const MAX_CENTS = 500000;

/** Optional Palestine donation added to the order. `value` is cents; 0 = none. */
export const DonationBox = ({ value, onChange }) => {
  const [custom, setCustom] = useState("");
  const isPreset = PRESETS.includes(value);

  const applyCustom = (raw) => {
    const clean = raw.replace(/[^\d.]/g, "");
    setCustom(clean);
    const cents = Math.round(parseFloat(clean || "0") * 100);
    onChange(Number.isFinite(cents) && cents > 0 ? Math.min(cents, MAX_CENTS) : 0);
  };

  return (
    <div data-testid="donation-box" className={`rounded-2xl border p-4 sm:p-5 transition-colors ${value ? "border-[#007a3d]/40 bg-[#007a3d]/[0.04]" : "border-[#e3e2dc] bg-[#ffffff]"}`}>
      <div className="flex items-start gap-3">
        <span className={`mt-0.5 h-8 w-8 shrink-0 rounded-full flex items-center justify-center ${value ? "bg-[#007a3d] text-white" : "bg-[#f3f2ec] text-[#007a3d]"}`}><Heart size={14} strokeWidth={2.5} fill={value ? "currentColor" : "none"} /></span>
        <div className="min-w-0">
          <p className="font-display font-extrabold uppercase text-sm leading-tight">Donate to Palestine</p>
          <p className="mt-1.5 text-[12px] leading-relaxed text-[#5f5e5a]">Add a donation to your order and stand with Palestine. Every contribution makes a difference — and a portion of every Palestine Edition purchase already goes to the cause.</p>
          <p className="mt-1.5 text-[12px] leading-relaxed text-[#0a0a0b] font-medium">Jazakum Allahu khayran for shopping with purpose.</p>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-2">
        {PRESETS.map((c) => (
          <button key={c} type="button" data-testid={`donation-preset-${c / 100}`} onClick={() => { setCustom(""); onChange(value === c ? 0 : c); }}
            className={`h-11 rounded-full font-mono-d text-[11px] tracking-[0.1em] border transition-colors ${value === c ? "bg-[#007a3d] border-[#007a3d] text-white" : "bg-[#ffffff] border-[#e3e2dc] hover:border-[#007a3d]"}`}>
            ${c / 100}
          </button>
        ))}
        <label className={`h-11 rounded-full border flex items-center px-3 gap-1 font-mono-d text-[11px] tracking-[0.1em] transition-colors ${value && !isPreset ? "bg-[#007a3d] border-[#007a3d] text-white" : "bg-[#ffffff] border-[#e3e2dc] focus-within:border-[#007a3d]"}`}>
          <span>$</span>
          <input data-testid="donation-custom-input" inputMode="decimal" placeholder="Other" value={custom} onChange={(e) => applyCustom(e.target.value)}
            className="w-full min-w-0 bg-transparent outline-none placeholder:text-[#5f5e5a]/70 text-inherit" />
        </label>
      </div>
      {value > 0 && (
        <div className="mt-3 flex items-center justify-between">
          <p data-testid="donation-selected" className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#007a3d]">Adding ${(value / 100).toFixed(2)} for Palestine</p>
          <button type="button" data-testid="donation-remove" onClick={() => { setCustom(""); onChange(0); }} className="font-mono-d text-[10px] uppercase tracking-[0.15em] text-[#5f5e5a] hover:text-[#ff2a85]">Remove</button>
        </div>
      )}
    </div>
  );
};
